<template>
  <footer class="footer">
    <div class="footer__pad">
      <div
        class="footer layout__main-container layout__main-container--narrow layout--padding-top-md layout--padding-bottom-md"
      >
        <Logo class="logo logo--light" style="width:139px;height:14px;" />
        <p class="layout--margin-top-none layout--margin-bottom-md">
          by
          <a
            href="https://www.webadvanced.com/"
            target="_blank"
            class="link link--footer"
            >Web Advanced</a
          >
        </p>
        <div class="footer__divider"></div>
        <div class="footer__wrap layout--margin-top-sm">
          <p class="footer__copyright">
            MotionMail © Copyright {{ new Date().getFullYear() }}. All rights
            reserved.
          </p>
          <p class=" layout--margin-bottom-none">
            <a href="/privacy" class="link link--footer">Privacy Policy</a>
            and
            <a href="/terms" class="link link--footer">Terms of Use</a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Logo from "../assets/icons/motionmail-logo-2021.svg";
export default {
  name: "Footer",
  components: { Logo },
};
</script>

<style lang="scss">
@import "../styles/pages/_footer.scss";
</style>
